import protoRoot from "../proto-root";

const name = "stopMonitoringRPCRequest";

function create() {
  const StopMonitoringRPCRequest = protoRoot.lookupType(
    "comm.StopMonitoringRPCRequest"
  );

  return { payload: StopMonitoringRPCRequest.create(), name };
}

export default {
  create,
  name
};
